"use strict";

window.FoG = window.FoG || {};

window.FoG.Memberful = (function($) {
  var hasBeenSet = false;
  var pollingForLogin = false;
  var COOKIE_MEMBERFUL_REDIRECT = 'fog-memberful_redirect';
  var COOKIE_INITIAL_ARTICLE = 'fog-initialArticle';
  var COOKIE_REDIRECT_AFTER_LOGIN = 'fog-redirectAfterLogin';
  
  function init() {
    if (!Cookies.get(COOKIE_INITIAL_ARTICLE)) {
      Cookies.set(COOKIE_INITIAL_ARTICLE, window.location.pathname, { sameSite: 'None' });
    }

    if (hasBeenSet) { return; }
    
    $('a[href*="futureofgood.memberful.com"]').each(function (idx, el) {
      var eventType = null;
      var href = el.getAttribute('href');

      if (href.includes('sign_out')) {
        el.addEventListener("click", function() {
          Cookies.remove(COOKIE_REDIRECT_AFTER_LOGIN);
          logUserEvent('signout');
        });
      }
      else if (href.includes('auth')) {
        el.addEventListener("click", function() { logUserEvent('signin'); });
      }
      else if (href.includes('register')) {
        el.addEventListener("click", function() { logUserEvent('register'); });
      }
    });
    
    // Detect an iframe, which indicates a behind-the-scenes login to Memberful, indicating
    // we should redirect the user on the next request.
    if (window.top != window.self) {
      Cookies.set(COOKIE_REDIRECT_AFTER_LOGIN, 1, { expires: 300 /* 5 minutes */, sameSite: 'None' });
    }
    
    var redirect = FoG.urlParam('memberful-redirect', window.top.location.search) || window.top.location.href;
    
    // Don't set the redirect cookie for home page requests, since Memberful's signin process hits the home page, 
    // which would overwrite the cookie.
    if (window.top.location.pathname && window.top.location.pathname !== '/') {
      setRedirectCookie(redirect);
    }
    
    window.addEventListener("message", handleMemberfulPostMessage, false);
  }
  
  /**
   * Unfortunately the Memberful js doesn't have usable hooks, so instead we have to spy on the communciation
   * with the memberful iframe to determine what's going on.  This is subject to change without notice, but
   * currently they're using the pmrpc message-passing library from here: https://github.com/izuzak/pmrpc
   */
  function handleMemberfulPostMessage(e) {
    if (!window.MemberfulOptions) { return; }
    if (e.origin !== window.MemberfulOptions.site) { return; }

    if (!e.data || !e.data.substring) { return; }
    // Not a pmrpc message: Ignore
    var data = JSON.parse(e.data.substring("pmrpc.".length));
    
    // pmrpc has changed versions: log a warning, but continue processing
    if (!data.jsonrpc || data.jsonrpc !== '2.0') {
      console.warn("Unexpected jsonrpc version: ", data.jsonrpc);
    }
    
    $('body').toggleClass('has-memberful-overlay', !!$('#memberful-iframe-for-overlay').is(':visible'));
    
    var method = data.method;
    var popupIsClosing = (method === 'close');
    var userLoggedIn = (method === 'performSilentLogin');

    /* Not 100% sure what's happening here, but closing the popup always seems to
     * result in a message with no method, no params, an ID, and a result of true.
     * normally the "popupIsClosing" variable is all we need, but if a user opens
     * the popup and then presses Esc, we don't always get a "closed" signal and
     * need to use this method instead. */
    var popupIsComplete = (!method && data.id && data.result === true);
    var initiateReload = userLoggedIn || popupIsClosing || popupIsComplete;

    if (!pollingForLogin && initiateReload) {
      // Same caveat as above - this is dependent on the Memberful 3rd-party overlay and
      // is not guaranteed to work forever.
      var memberfulFrame = document.getElementById('memberful-iframe-for-overlay');
      var memberfulOverlay = memberfulFrame && memberfulFrame.parentElement;
      var overlayHidden = (memberfulOverlay && memberfulOverlay.style.display === 'none');

      var redirectIntervalHandle = window.setInterval(function() {
        var matchingIframes = $('iframe').filter(function() {
          var src = this.src;
          
          if (!this.src.includes('code=') || !this.src.includes('memberful_endpoint=auth')) {
            return false;
          }
          
          var doc = this.contentDocument || this.contentWindow.document;
          return doc && doc.getElementById('nacl-mainNav');
        });

        if (!matchingIframes.length) {
          return false;
        }
        
        window.location.href = '/reredirect.php';
        window.clearInterval(redirectIntervalHandle);
      }, 600);
    }
  }
  
  
  function logUserEvent(eventType, params) {
    if (window.gtag) {
      params = Object.assign({ userId: getUserId() }, params);
      gtag('event', eventType, params);
    }

    if (window.ga) {
      ga('send', {
        hitType: 'event',
        eventCategory: 'userEvent',
        eventAction: eventType,
        eventLabel: getUserId()
      });
    }
  }
  
  function getUserId() {
    return $('.userBox__username').data('fogUserId');
  }
  
  function setRedirectCookie(redirect) {
    hasBeenSet = true;
    Cookies.set(COOKIE_MEMBERFUL_REDIRECT, redirect, { expires: 300 /* 5 minutes */, sameSite: 'None' });
  }
  
  function augmentTrackingData(parameters) {
    parameters = parameters || {};
    parameters.initialArticle = Cookies.get(COOKIE_INITIAL_ARTICLE) || '';
    parameters.signupArticle = Cookies.get(COOKIE_MEMBERFUL_REDIRECT) || '';
    return parameters;
  }
  

  $(init);
  
  return {
    augmentTrackingData: augmentTrackingData,
    getUserId: getUserId,
    logUserEvent: logUserEvent,
    setRedirectCookie: setRedirectCookie
  };
})(jQuery);
